export const mediaDuration = (duration: number) => {
  const time = duration
  const hours = Math.floor(time / 3600)
  const minutes = Math.floor((time % 3600) / 60)
  const seconds = time - (hours * 3600 + minutes * 60)
  const stringHours = hours.toString().padStart(2, '0')
  const stringMinutes = minutes.toString().padStart(2, '0')
  const stringSeconds = seconds.toString().padStart(2, '0')
  return `${stringHours}:${stringMinutes}:${stringSeconds}`
}
